module.exports = __webpack_public_path__ + "img/D202204_3.02a4af9f.jpg";